// extracted by mini-css-extract-plugin
module.exports = {"container":"jU","bottomGradient":"jV","image":"jW","brandLogoFrame":"jX","logoImage":"jY","logoImageFrame":"jZ"};